import { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { groupCubeRows, usd, type ExecutiveTransaction } from "../../data/executiveOverview";
import "./fishbone-tree-panel.css";

const categoryKeys = ["Category_L1", "Category_L2", "Category_L3", "Category_L4"] as const;
const barColors = ["#492750", "#957AB8", "#3265AA", "#61BA93"];

export function FishboneCategorySpendTree({ rows }: { rows: ExecutiveTransaction[] }) {
  const [selected, setSelected] = useState<(string | null)[]>([null, null, null, null]);

  useEffect(() => {
    setSelected([null, null, null, null]);
  }, [rows]);

  const levels = categoryKeys.map((key, index) => {
    const members = rows.filter((row) => categoryKeys.slice(0, index).every((parent, parentIndex) => !selected[parentIndex] || row[parent] === selected[parentIndex]));
    return groupCubeRows(members, key);
  });

  const selectCategory = (level: number, name: string) => {
    setSelected((current) => current.map((value, index) => index < level ? value : index === level && value !== name ? name : null));
  };

  return (
    <div className="fishbone-tree-panel">
      <div className="fishbone-tree-panel__title">FISHBONE CATEGORY SPEND TREE (L1 → L2 → L3 → L4)</div>
      <div className="fishbone-tree-panel__info">Click a category to drill recursively into the next level.</div>
      <div className="fishbone-tree-panel__row">
        {levels.map((groups, level) => (
          <div className="fishbone-tree-panel__col" key={categoryKeys[level]}>
            <div className="fishbone-tree-panel__level-label">
              <span>LEVEL {level + 1}</span>
              <span className="fishbone-tree-panel__level-numbers"><span className="fishbone-tree-panel__level-number">{groups.length}</span></span>
            </div>
            <div className="fishbone-tree-panel__level-box" style={{ maxHeight: 360, overflowY: "auto" }}>
              {groups.map((group) => (
                <div className="fishbone-tree-panel__box" key={group.label} style={selected[level] === group.label ? { background: "#F4EBF6" } : undefined}>
                  <button type="button" className="fishbone-tree-panel__box-header" aria-pressed={selected[level] === group.label} onClick={() => selectCategory(level, group.label)} style={{ width: "100%", cursor: "pointer", border: 0, textAlign: "left" }}>
                    <span className="fishbone-tree-panel__box-title">{group.label.toUpperCase()}</span>
                    {level < 3 && <ChevronRight size={16} color="#364153" />}
                  </button>
                  <div className="fishbone-tree-panel__bar-row">
                    <div className="fishbone-tree-panel__bar-wrap">
                      <div className="fishbone-tree-panel__bar-bg" />
                      <div className="fishbone-tree-panel__bar" style={{ width: `${group.amount / (groups[0]?.amount || 1) * 100}%`, background: barColors[level] }} />
                    </div>
                    <div className="fishbone-tree-panel__value">{usd(group.amount)}</div>
                  </div>
                </div>
              ))}
              {!groups.length && <div className="fishbone-tree-panel__box">No matching categories</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}